<template>
  <button
    :class="[
      'drawer-action',
      'drawer-action--' + variant,
      'drawer-action--' + tone,
      { 'drawer-action--disabled': disabled, 'drawer-action--wide': variant === 'primary' }
    ]"
    :disabled="disabled"
    :title="tooltip"
    @click.stop="onClick"
  >
    <v-icon small v-if="icon" class="drawer-action__icon">{{ icon }}</v-icon>
    <span class="drawer-action__label">{{ label }}</span>
  </button>
</template>

<script>
// Botón de acción del drawer. 2 variantes (primary/secondary) × 4 tonos
// (accent/danger/success/muted). El primary es full width y tiene padding
// vertical más alto que el secondary (DRAWERS-DESIGN-SPEC §5.5).
export default {
  name: 'DrawerActionButton',
  props: {
    label: { type: String, required: true },
    icon: { type: String, default: '' },
    tooltip: { type: String, default: '' },
    // primary: full width + padding generoso
    // secondary: outline, tamaño normal
    variant: { type: String, default: 'primary', validator: v => ['primary', 'secondary'].indexOf(v) !== -1 },
    // accent | danger | success | muted | warning
    tone: { type: String, default: 'accent' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    onClick() { if (!this.disabled) this.$emit('click') },
  },
}
</script>

<style scoped>
.drawer-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.12s, opacity 0.12s, transform 0.05s;
  font-family: inherit;
  line-height: 1.2;
}

.drawer-action--primary {
  padding: 12px 16px;
  width: 100%;
  font-size: 14px;
}

.drawer-action--secondary {
  padding: 7px 12px;
  background: transparent !important;
  border: 1px solid currentColor;
}

.drawer-action--wide {
  width: 100%;
}

/* Tonos (variant=primary) */
.drawer-action--primary.drawer-action--accent {
  background: var(--kln-accent);
  color: #041022;
}

.drawer-action--primary.drawer-action--danger {
  background: var(--kln-alert-danger);
  color: #fff;
}

.drawer-action--primary.drawer-action--success {
  background: var(--kln-status-online);
  color: #041022;
}

.drawer-action--primary.drawer-action--warning {
  background: var(--kln-alert-warning);
  color: #0d0c00;
}

.drawer-action--primary.drawer-action--muted {
  background: rgba(255, 255, 255, 0.1);
  color: var(--kln-text, rgba(255, 255, 255, 0.9));
}

/* Tonos (variant=secondary) */
.drawer-action--secondary.drawer-action--accent {
  color: var(--kln-accent);
}

.drawer-action--secondary.drawer-action--danger {
  color: var(--kln-alert-danger);
}

.drawer-action--secondary.drawer-action--success {
  color: var(--kln-status-online);
}

.drawer-action--secondary.drawer-action--warning {
  color: var(--kln-alert-warning);
}

.drawer-action--secondary.drawer-action--muted {
  color: var(--kln-text-muted, rgba(255, 255, 255, 0.55));
}

.drawer-action:hover:not(.drawer-action--disabled) {
  filter: brightness(1.08);
}

.drawer-action:active:not(.drawer-action--disabled) {
  transform: scale(0.99);
}

.drawer-action--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.drawer-action__icon {
  color: inherit !important;
}

.drawer-action__label {
  text-align: center;
}
</style>
